import React from 'react';
import cn from 'classnames';

import MenuTranscibedItem from '../MenuTranscibedItem';

import styles from './MenuTranscibedSection.module.css';

const MenuTranscibedSection = ({ animate, margin, name, items, delay }) => (
  <li className={cn({ 'mb-1': margin })}>
    <div
      className={cn(styles.title, { [`${styles.animate}`]: animate })}
      styles={{ animationDelay: `${delay}ms` }}
    >
      <span className="text-sm text-black">{name}</span>
    </div>
    <ul>
      {items.map((item, i) => (
        <MenuTranscibedItem
          key={`menu-item${item.name}-${name}`}
          animate={animate}
          item={item}
          delay={delay + 100 * (i + 1)}
        />
      ))}
    </ul>
  </li>
);

export default MenuTranscibedSection;
